import accounts from '@/helpers/accountsIframe';
import { waitForPocket } from '@/helpers/pocket';

export const PARTNER_COOKIE_NAME = 'd-partner';

// Ancorado em início/`;` de propósito: `includes('d-partner')` casaria com
// qualquer cookie cujo nome termine assim.
const PARTNER_COOKIE_REGEX = /(?:^|;\s*)d-partner=/;

// Menor que o do ProUni (8s): lá, sem POCKET não existe login; aqui o pior caso
// é o aluno digitar o cupom à mão.
const POCKET_WAIT_MS = 3000;

export const hasPartnerCookie = (): boolean =>
  typeof document !== 'undefined' && PARTNER_COOKIE_REGEX.test(document.cookie);

/**
 * Cupom fixo da UG que vem no JWT do parceiro (cookie `d-partner`), no campo `promocode`.
 *
 * Sem o cookie nada aqui roda — nem a espera pelo POCKET. A matrícula do
 * processo seletivo comum não pode pagar por uma integração que não é dela.
 */
export const getPartnerCouponFromCookie = async (): Promise<string | undefined> => {
  if (!hasPartnerCookie()) return undefined;

  const isPocketReady = await waitForPocket(POCKET_WAIT_MS);
  if (!isPocketReady) return undefined;

  const coupon = accounts.getPartnerDataFromCookie(PARTNER_COOKIE_NAME)?.promocode;

  return typeof coupon === 'string' && coupon.trim() ? coupon.trim() : undefined;
};

export default { PARTNER_COOKIE_NAME, hasPartnerCookie, getPartnerCouponFromCookie };
